import React from 'react';
import ProductCard from '../ProductCard';
import { Package } from 'lucide-react';

/** "Our Products" tab: grid of ProductCard, or empty state. */
const SupplierProductsTab = ({ supplier, products }) => (
  <>
    <div className="bg-white border border-gray-200 rounded-md px-4 py-3 mb-4 flex items-center justify-between">
      <div className="text-sm text-gray-700">
        {products.length} product{products.length !== 1 ? 's' : ''} from {supplier.name}
      </div>
    </div>
    {products.length === 0 ? (
      <div className="bg-white border border-gray-200 rounded-md py-16 text-center text-gray-600">
        <Package className="w-10 h-10 text-gray-400 mx-auto mb-3" />
        No products listed yet from this vendor.
      </div>
    ) : (
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {products.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    )}
  </>
);

export default SupplierProductsTab;
